import { NgModule } from '@angular/core';
import { NavbarTopHeaderComponent } from './tuition-navbar-top-header.component';
import { EdAssistUIHeaderModule } from '@edassist-ui/header';
import { TuitionNavbarModule } from '../tuition-navbar';
import { EdAssistUIClientLogoModule } from '@edassist-ui/client-logo';
import { CommonModule } from '@angular/common';
import { EdAssistUIIconModule } from '@edassist-ui/icon';
import { TuitionMobileMenuModule } from '@tuition/shared/components/tuition-mobile-menu';
import { ImpersonationBarComponentModule } from '@tuition/shared/components/impersonation-bar/impersonation-bar.module';

const COMPONENTS = [NavbarTopHeaderComponent];

@NgModule({
	imports: [
		CommonModule,
		EdAssistUIHeaderModule,
		EdAssistUIClientLogoModule,
		TuitionNavbarModule,
		EdAssistUIIconModule,
		TuitionMobileMenuModule,
		ImpersonationBarComponentModule
	],
	exports: COMPONENTS,
	declarations: COMPONENTS
})
class EdAssistUINavbarTopHeaderModule {}

export { EdAssistUINavbarTopHeaderModule, NavbarTopHeaderComponent };
